export default {
  /*
     * Questions used by incremental data forms and RYI forms
     *
     * If you choose to add a new question to this array you will also need to
     * update the resolveQuestionNameToComponent in resources/assets/vue/components/incremental-data/incremental-data-provider.vue
     * as this maps the below questions to the components.
     *
     * You will also need to update the RYI component at
     * resources/assets/vue/components/registration/register-interest
     *
     */
  getRegistrationQuestions(state) {
    const questions = [
      {
        name: 'fullname',
        order: 1,
        valid: state.fullname && state.fullname.length,
      },
      {
        name: 'gender',
        order: 2,
        valid: state.gender !== 0 && state.gender !== null,
      },
      {
        name: 'uk_based',
        order: 3,
        valid: state.uk_based !== null,
      },
      {
        name: 'postcode',
        order: 4,
        valid: state.uk_based === 0 ? true : state.postcode !== null,
      },
      {
        name: 'institution_start_year',
        order: 5,
        valid: state.institution_start_year !== null,
      },
      {
        name: 'subscriptions',
        order: 6,
        valid: state.subscription_decision !== 0,
      },
      {
        name: 'job_roles',
        order: 7,
        valid: state.jobRoles.length > 0,
      },
      {
        name: 'job_types',
        order: 8,
        valid: state.jobTypes.length > 0,
      },
      ...process.env.DIVERSITY_DATA_ENABLED ? [
        {
          name: 'ethnicity',
          order: 9,
          valid: state.ethnicity !== null,
        },
        {
          name: 'free_school_meals',
          order: 10,
          valid: state.free_school_meals !== null,
        },
        {
          name: 'parent_profession',
          order: 11,
          valid: state.parent_profession !== null,
        },
      ] : [],
    ];

    return questions.sort((a, b) => a - b);
  },

  /*
   * Returns and array of names of incomplete questions that the user still needs to answers
   * in incremental data and RYI
   *
   * @returns [name, name, ...] - where name is the field name from getRegistrationQuestions
   */
  getIncompleteQuestions(state, getters) {
    let inCompleteQuestions = getters.getRegistrationQuestions;

    if (state.loggedIn) {
      inCompleteQuestions = getters.getRegistrationQuestions.filter((item) => {
        return !getters.isQuestionComplete(item.name);
      });
    }

    return inCompleteQuestions.map((item) => item.name);
  },

  /*
   * Calculates if a question is completed, used by above getIncompleteQuestions method
   */
  isQuestionComplete: (state, getters) => (questionNameNeedle) => {
    const foundQuestion = getters.getRegistrationQuestions
      .find((item) => item.name === questionNameNeedle);

    return foundQuestion.valid;
  },
};
